import create from 'zustand';

import { GoalsStoreState } from './useGoalsStore.types';
import { SequenceGoal } from '../components/CollectionAndSequencing/Overview/SequenceGoal/SequenceGoal.types';

const useGoalsStore = create<GoalsStoreState>((set) => ({
  lifetimeGoal: undefined,
  setLifetimeGoal: (lifetimeGoal: SequenceGoal) => {
    set(() => {
      return {
        lifetimeGoal,
      };
    });
  },
}));

export default useGoalsStore;
